import { render } from "./UploadsView.vue?vue&type=template&id=afd57a36"
import script from "./UploadsView.vue?vue&type=script&lang=js"
export * from "./UploadsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__